import axios from '../utils/axios';

export default function getVerifiedCompanies(recId,params) {
    return axios.get(`/admin/${recId}/companyManagement/v1/companies/all`,{ params })
}
